/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const borderColor = '#00519C';

const styles = StyleSheet.create({
	tableContainer: {
		marginTop: 24,
		borderWidth: 1,
		borderColor: borderColor,
	},

	container: {
		flexDirection: 'row',
		backgroundColor: '#00519C',
		color: '#fff',
		height: 24,
		alignItems: 'center',
	},

	headerCell: {
		fontSize: 10,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
		padding: 4,
	},

	id: { width: '8%', textAlign: 'center' },
	name: { width: '20%', textAlign: 'left' },
	allocation: { width: '30%', textAlign: 'left' },
	coverage: { width: '12%', textAlign: 'center' },
	date: { width: '30%', textAlign: 'center', borderRightWidth: 0 }
});

const paginate = (array, perPage) => {
	const pages = [];
	for (let i = 0; i < array.length; i += perPage)
		pages.push(array.slice(i, i + perPage));
	return pages;
};

const InvoiceItemsTable = (props) => {
	const itemsPerPage = 18;
	const pages = paginate(props.invoice, itemsPerPage);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<React.Fragment key={pageIndex}>

					{/* Insert break ONLY for pages after the first */}
					{pageIndex > 1 && <View break />}

					{/* Page Section */}
					<View wrap={true}>
						{/* Table Header */}
						<View style={styles.container}>
							<View style={styles.container}>
								<Text style={[styles.headerCell, styles.id]}>Id</Text>
								<Text style={[styles.headerCell, styles.name]}>Name</Text>
								<Text style={[styles.headerCell, styles.allocation]}>Allocation</Text>
								<Text style={[styles.headerCell, styles.coverage]}>Coverage</Text>
								<Text style={[styles.headerCell, styles.date]}>Date</Text>
							</View>
						</View>

						{/* Table Rows */}
						<InvoiceTableRow data={pageData} />
					</View>

				</React.Fragment>
			))}
		</>

	);
};

export default InvoiceItemsTable;
